import React from 'react';
import ReactApexChart from 'react-apexcharts';

const LineChart = ({
    chartSeries,
    colors,
    categories
}) => {
    const chartOptions = {
        stroke: {
            width: 2, // Change this to make line smaller (default is 2, try 1 for thinner)
            curve: 'smooth', // Optional: 'straight' for straight lines,
            colors: colors
        },
        chart: {
            height: 350,
            type: 'line',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: categories,
        },
        grid: {
            borderColor: '#e7e7e7',
            strokeDashArray: 5,
            yaxis: {
                lines: {
                    show: true // This shows horizontal grid lines
                }
            },
            xaxis: {
                lines: {
                    show: true // Hide vertical grid lines if you want
                }
            }
        },
    };

    return (
        <ReactApexChart
            options={chartOptions}
            series={chartSeries}
            type="line"
            height={350}
        />
    );
};

export default LineChart;